<template lang="pug">
.footer
  .footer-content
    .romatch
      span © Romatch {{ new Date().getFullYear() }}
      router-link(v-if="!loggedIn" to="/login") Login
      button.logout(v-else @click="logout") Logout
    slot
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters('auth', ['loggedIn']),
  methods: {
    ...mapActions('auth', ['signOut']),
    async logout() {
      this.signOut()
      this.$router.push({ name: 'home' })
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

.footer
  grid-column 1 / -1
  padding 1.4rem
  clear both
  font-size 1.4rem
  text-align left
  background-color #0e1c33
  color footer-color

  a
    margin-left 1rem
    color wheat

    &:hover
      color white

  .romatch
    margin-bottom 1rem

    @media only screen and (min-width: small)
      margin-bottom 0

.footer-content
  max-width romatch-max-width
  margin auto

  @media only screen and (min-width: small)
    display flex
    justify-content space-between
    margin-bottom 0

.logout
  color wheat
  background transparent
  border none
  cursor pointer

  &:hover
    color white
</style>
